export enum TemConnectionBodySteps {
  Connecting = 'CONNECTING',
  Success = 'SUCCESS',
  Failure = 'FAILURE',
  NotAllowed = 'NOT_ALLOWED',
  RefusedByCustomer = 'REFUSED_BY_CUSTOMER',
}

export type TemConnectingStepStatus = Record<
  'helpdeskSession' | 'redirectingToDesktop' | 'waitingForTerminal',
  TemConnectionBodySteps
>;

export interface TemConnectionModalBodyProps {
  readonly step: TemConnectionBodySteps;
  readonly connectingStepStatus?: TemConnectingStepStatus;
}
